exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".drop-toggle {\n  background-color: #fff;\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n  cursor: hand;\n  border: 1px solid #ccc;\n  width: 100%;\n  text-align: left;\n  height: 35px; }\n\n.drop-toggle i {\n  float: right; }\n\n.drop-show {\n  padding: 4px;\n  min-width: 99%;\n  background-color: #FFF;\n  border: 1px solid #BABABA;\n  position: absolute;\n  z-index: 999 !important;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\n  margin-left: 0px; }\n\n.drop-show label {\n  display: block;\n  font-size: 10px;\n  cursor: pointer; }\n\n.drop-show label input {\n  vertical-align: top; }\n\n.drop-show label span {\n  display: inline-block; }\n\n.require-input-1 {\n  border-left: 5px solid #F95372; }\n\n.require-input-2 {\n  border-left: 5px solid #42A948; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/select2/select2.component.scss
// module id = 1930
// module chunks = 66